<template lang="pug">
  .row
    .col-md-8
      b-card.mb-2
        .container
          h4 ACCOUNT VERIFICATION
          content-loader(:height="7", v-if="alert.loading")
          h4.text-success(v-else-if="isVerified")
            span
              font-awesome-icon.mr-2(icon="check")
              span VERIFIED
          button-load(v-else="", :flag="busyPersona", label="VERIFY NOW", classes="btn-outline mt-3", @clicked="verifyMe()")
      b-card
        p PROFILE
        content-loader(:height="7", v-if="alert.loading")
        form.mt-3(v-else-if="inputForm", @submit.prevent='onSubmit')
          .row
            .col-md-6
              b-form-group
                label FIRST NAME
                b-form-input(name='firstname', type='text', v-model='inputForm.firstname', required='', placeholder='firstname', autocomplete="fname", @keyup="setDisplayName()")
            .col-md-6
              b-form-group
                label LAST NAME
                b-form-input(name='lastname', type='text', v-model='inputForm.lastname', required='', placeholder='lastname', autocomplete="lname", @keyup="setDisplayName()")
            .col-12
              b-form-group
                label
                  span DISPLAY NAME
                  span.small.ml-2 (This is what customers will see)
                b-form-input(name='display_name', type='text', v-model='inputForm.display_name', required='', autocomplete="")
            .col-md-4
              b-form-group
                label PHONE
                b-form-input(type='text', v-model='inputForm.phone', required='', autocomplete="tel")
            .col-md-4
              b-form-group
                label EMAIL
                b-form-input(type='email', v-model='inputForm.email', required='', autocomplete="email")
            .col-md-4
              b-form-group
                label BASE CITY
                b-form-input.form-control(type='text', required, v-model='inputForm.base', placeholder='City')
            .col-md-6
              b-form-group(label="PASSWORD")
                b-form-input(type="password", name="passwordOld", v-model="inputForm.passwordOld", placeholder='Leave blank to keep unchanged')
            .col-md-6
              b-form-group(label="NEW PASSWORD")
                b-form-input(type="password", name="passwordNew", v-model="inputForm.passwordNew", placeholder='Leave blank to keep unchanged', pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
            .col-12(v-if="inputForm.passwordNew")
              p Password must be atleast 8 characters, with a number and a capital letter.
          .row
            .col-md-4
              b-form-group
                label INSTAGRAM
                b-form-input.form-control(type='url', v-model='inputForm.instagram_url', placeholder='e.g. https://www.instagram.com/wall_collective/')
            .col-md-4
              b-form-group
                label FACEBOOK
                b-form-input.form-control(type='url', v-model='inputForm.facebook_url', placeholder='e.g. https://www.facebook.com/wall_collective/')
            .col-md-4
              b-form-group
                label BEHANCE
                b-form-input.form-control(type='url', v-model='inputForm.behance_url', placeholder='e.g. https://www.behance.com/wall_collective/')
            .col-12
              b-form-group
                label SHORT BIO
                b-form-textarea(rows='3', max-rows='6' v-model='inputForm.bio', required='', placeholder='Tell us about yourself')
          .form-group
            button-load(type="submit", :flag="alert.busy", label="SAVE", classes="btn-outline")
            // b-button.btn-clear(@click="deleteAccount()") Delete Account
    .col-md-4
      b-card
        p I CONSENT TO
        content-loader(:height="7", v-if="alert.loading")
        form.mt-3(v-else-if="inputForm", @submit.prevent='onSubmit')
          b-form-group
            b-form-checkbox(v-for='item in inputForm.consent', :key="item.id", v-model='item.value', switch) {{ item.display_text }}
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';
import router from '@/router';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      inputForm: null,
      busyPersona: false,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['updateAccount', 'logout']),
    ...mapMutations('account', ['setAccountVerified']),
    onSubmit() {
      this.updateAccount({ form: this.inputForm, id: this.account.user.artist_id });
    },
    setDisplayName() {
      this.inputForm.display_name = `${this.inputForm.firstname} ${this.inputForm.lastname}`;
    },
    async verifyMe() {
      if (process.env.NODE_ENV === 'production') {
        this.busyPersona = true;
        // eslint-disable-next-line no-undef
        const client = new Persona.Client({
          templateId: 'tmpl_9sqr29pCrKni743khM4bRq1X',
          environment: process.env.VUE_APP_PERSONA_ENV,
          onLoad: (_error) => {
            client.open(_error);
            this.busyPersona = false;
          },
          onComplete: async (inquiryId) => {
          // Inquiry completed. Optionally tell your server about it.
            this.busyPersona = true;
            try {
              await userService.verifyPersona(this.profileId, inquiryId);
              this.setAccountVerified();
              if (this.$route.query.sendmeback) {
                router.push(this.fromUrl);
              } else {
                this.success('Account verified');
              }
            } catch (error) {
              this.error(error);
            }
            this.busyPersona = false;
          },
        });
      } else {
        this.busyPersona = true;
        try {
          await userService.verifyPersona(this.profileId, '0000000000000000');
          this.setAccountVerified();
          if (this.$route.query.sendmeback) {
            router.push(this.fromUrl);
          } else {
            this.success('Account verified');
          }
        } catch (error) {
          this.error(error);
        }
        this.busyPersona = false;
      }
    },
  },
  mounted() {
    this.$loadScript('https://cdn.withpersona.com/dist/persona-v3.7.3.js')
      .then(() => {
      // Script is loaded, do something
        console.log('Persona ready');
      })
      .catch(() => {
        console.log('Persona failed');
      // Failed to fetch script
      });
  },
  async created() {
    try {
      this.busy();
      this.inputForm = await userService.getProfile(this.account.user.artist_id);
      this.clear();
      if (this.$route.query.launch === 'accountVerify') {
        this.verifyMe();
      }
    } catch (error) {
      this.error('Could not find user');
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/AccountProfile.vue